import Vue from 'vue'
import { store } from '../../components/front/vue/store/store'
// import BidBoard from 'FrontComponents/vue/BidBoard/Index.vue'
// import AuctionLot from 'FrontComponents/vue/AuctionLot/Index.vue'
// import HybridSystemLive from 'FrontComponents/vue/Hybrid/HybridSystemLive.vue'
// import HybridSystemPreview from 'FrontComponents/vue/Hybrid/HybridSystemPreview.vue'
// import RelatedLots from 'FrontComponents/vue/Lot/RelatedLots.vue'
import PortalVue from 'portal-vue'
// import Lots from 'FrontComponents/vue/Lot/Lots.vue'
// import WishList from 'FrontComponents/vue/Account/WishList.vue'

// let mixin = {
//     methods: {
//         route: route,
//     },
// }

if (document.querySelector('#lot-bidbar')) {
    const BidBoard = () => import(/* webpackChunkName: "assets/bid-board" */ '../../components/front/vue/BidBoard/Index.vue')

    new Vue({
        el: '#lot-bidbar',
        store,
        mixins: {
            methods: {
                route: route,
            },
        },
        components: {
            BidBoard,
        },
    })
}

if (document.querySelector('#related-lots') || document.querySelector('#lot-listing')) {
    Vue.use(PortalVue)

    if (document.querySelector('#lot-listing')) {
        const AuctionLot = () => import(/* webpackChunkName: "assets/auction-lot" */ '../../components/front/vue/AuctionLot/Index.vue')

        Vue.component('pagination', require('laravel-vue-pagination'))

        new Vue({
            el: '#lot-listing',
            store,
            mixins: {
                methods: {
                    route: route,
                },
            },
            components: {
                AuctionLot,
            },
        })
    }

    if (document.querySelector('#related-lots')) {
        const RelatedLots = () => import(/* webpackChunkName: "assets/related-lots" */ 'FrontComponents/vue/Lot/RelatedLots.vue')
        const Lots = () => import(/* webpackChunkName: "assets/lots" */ 'FrontComponents/vue/Lot/Lots.vue')
        const WishList = () => import(/* webpackChunkName: "assets/wish-list" */ 'FrontComponents/vue/Account/WishList.vue')

        new Vue({
            el: '#related-lots',
            store,
            mixins: {
                methods: {
                    route: route,
                },
            },
            components: {
                RelatedLots,
                Lots,
                WishList,
            },
        })
    }
}

if (document.querySelector('#hybrid-system-preview')) {
    const HybridSystemPreview = () => import(/* webpackChunkName: "assets/hybrid-system-preview" */ 'FrontComponents/vue/Hybrid/HybridSystemPreview.vue')

    new Vue({
        el: '#hybrid-system-preview',
        store,
        mixins: {
            methods: {
                route: route,
            },
        },
        components: {
            HybridSystemPreview,
        },
    })
}

if (document.querySelector('#hybrid-system-live')) {
    const HybridSystemLive = () => import(/* webpackChunkName: "assets/hybrid-system-live" */ 'FrontComponents/vue/Hybrid/HybridSystemLive.vue')

    new Vue({
        el: '#hybrid-system-live',
        store,
        mixins: {
            methods: {
                route: route,
            },
        },
        components: {
            HybridSystemLive,
        },
    })
}
